(function () {
  'use strict';

  function parseJsonAttribute(element, name, fallback) {
    if (!element) return fallback;
    var raw = element.getAttribute(name) || '';
    try {
      return JSON.parse(raw) || fallback;
    } catch (error) {
      try {
        var decoder = document.createElement('textarea');
        decoder.innerHTML = raw;
        return JSON.parse(decoder.value) || fallback;
      } catch (decodeError) {
        return fallback;
      }
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (Number(cents || 0) / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  }

  function fitTitle(element) {
    if (!element) return;
    element.style.height = 'auto';
    element.style.maxHeight = 'none';
    element.style.fontSize = '';
    var size = parseFloat(window.getComputedStyle(element).fontSize);
    var minSize = window.matchMedia('(max-width: 600px)').matches ? 26 : 32;
    while (size > minSize) {
      var lineHeight = parseFloat(window.getComputedStyle(element).lineHeight) || size * 1.08;
      if (element.scrollHeight <= lineHeight * 3 + 2) break;
      size -= 1;
      element.style.fontSize = size + 'px';
    }
  }

  function fitSingleLine(element) {
    if (!element) return;
    element.style.fontSize = '';
    var size = parseFloat(window.getComputedStyle(element).fontSize);
    var minSize = 12;
    while (size > minSize && element.scrollWidth > element.clientWidth + 1) {
      size -= 1;
      element.style.fontSize = size + 'px';
    }
  }

  function classifyHeading(text) {
    var value = String(text || '').toLowerCase().replace(/\s+/g, ' ').trim();
    if (/\b(size guide|dimension|dimensions|measurement|measurements|specification|specifications|product specification|product specifications|weight|capacity|package includes)\b/.test(value)) return 'dimensions';
    if (/\b(material|materials|construction|care|cleaning|maintenance|natural material|important notes)\b/.test(value)) return 'materials';
    if (/\b(shipping|returns?|delivery|refund|warranty)\b/.test(value)) return 'shipping';
    if (/\b(faq|q&a|questions?)\b/.test(value)) return 'faq';
    if (/\b(product overview|overview|description|key features|highlights?|suitable uses?|how to use|features?)\b/.test(value)) return 'overview';
    return 'overview';
  }

  function headingText(node) {
    if (!node || node.nodeType !== 1) return '';
    if (/^H[1-6]$/.test(node.tagName)) return node.textContent || '';
    if (node.tagName !== 'P' && node.tagName !== 'DIV') return '';
    var meaningfulChildren = Array.from(node.childNodes).filter(function (child) {
      return !(child.nodeType === 3 && !child.textContent.trim());
    });
    if (meaningfulChildren.length !== 1) return '';
    var emphasis = meaningfulChildren[0];
    if (emphasis.nodeType !== 1 || !/^(STRONG|B)$/.test(emphasis.tagName)) return '';
    return emphasis.textContent || '';
  }

  function parseDescription(section) {
    var source = section.querySelector('[data-v2-description-source]');
    if (!source || source.dataset.v2Parsed === 'true') return;
    var panels = {};
    section.querySelectorAll('[data-v2-panel]').forEach(function (panel) {
      panels[panel.dataset.v2Panel] = panel;
    });
    var current = panels.overview;
    Array.from(source.childNodes).forEach(function (node) {
      var heading = headingText(node);
      if (heading) {
        var target = panels[classifyHeading(heading)] || panels.overview;
        if (node.nodeType === 1 && node.tagName === 'H1') {
          var replacement = source.ownerDocument.createElement('h2');
          replacement.innerHTML = node.innerHTML;
          Array.from(node.attributes).forEach(function (attribute) { replacement.setAttribute(attribute.name, attribute.value); });
          node.replaceWith(replacement);
          node = replacement;
        }
        current = target;
      }
      current.appendChild(node);
    });
    source.dataset.v2Parsed = 'true';
  }

  function hideEmptyPanels(section) {
    var panels = Array.from(section.querySelectorAll('[data-v2-panel]'));
    panels.forEach(function (panel) {
      var meaningful = Array.from(panel.children).filter(function (child) {
        return !child.hasAttribute('data-v2-mobile-toggle');
      }).some(function (child) {
        return child.textContent.trim() || child.querySelector('img, table, details');
      });
      var tab = section.querySelector('[data-v2-tab="' + panel.dataset.v2Panel + '"]');
      panel.dataset.v2Empty = meaningful ? 'false' : 'true';
      if (tab) tab.hidden = !meaningful;
      if (!meaningful) panel.hidden = true;
    });
    var firstTab = section.querySelector('[data-v2-tab]:not([hidden])');
    if (firstTab) activateTab(section, firstTab.dataset.v2Tab);
  }

  function activateTab(section, name) {
    section.querySelectorAll('[data-v2-tab]').forEach(function (tab) {
      var selected = tab.dataset.v2Tab === name && !tab.hidden;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    section.querySelectorAll('[data-v2-panel]').forEach(function (panel) {
      var active = panel.dataset.v2Panel === name && panel.dataset.v2Empty !== 'true';
      panel.classList.toggle('is-active', active);
      if (window.matchMedia('(min-width: 990px)').matches) {
        panel.hidden = !active;
        panel.classList.remove('is-collapsed');
      } else if (panel.dataset.v2Empty !== 'true') {
        panel.hidden = false;
        panel.classList.toggle('is-collapsed', !active);
        var toggle = panel.querySelector('[data-v2-mobile-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', active ? 'true' : 'false');
      }
    });
  }

  function setupDetails(section) {
    section.querySelectorAll('[data-v2-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () { activateTab(section, tab.dataset.v2Tab); });
      tab.addEventListener('keydown', function (event) {
        var tabs = Array.from(section.querySelectorAll('[data-v2-tab]:not([hidden])'));
        var index = tabs.indexOf(tab);
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index += 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index -= 1;
        if (index >= 0 && index < tabs.length && index !== tabs.indexOf(tab)) {
          event.preventDefault();
          tabs[index].focus();
          activateTab(section, tabs[index].dataset.v2Tab);
        }
      });
    });
    section.querySelectorAll('[data-v2-mobile-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 990px)').matches) return;
        var panel = toggle.closest('[data-v2-panel]');
        if (!panel || panel.dataset.v2Empty === 'true') return;
        if (panel.classList.contains('is-collapsed')) {
          activateTab(section, panel.dataset.v2Panel);
        } else {
          panel.classList.add('is-collapsed');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
    activateTab(section, 'overview');
  }

  function deriveHighlights(section) {
    var list = section.querySelector('[data-v2-highlights]');
    if (!list || list.querySelector('[data-v2-highlight-item]')) {
      if (list && list.children.length) list.hidden = false;
      return;
    }
    var overview = section.querySelector('[data-v2-panel="overview"]');
    if (!overview) return;
    var nodes = Array.from(overview.children);
    var featureHeadingIndex = nodes.findIndex(function (node) {
      return /^h[2-6]$/i.test(node.tagName) && /key features?|highlights?/i.test(node.textContent || '');
    });
    var candidates = [];
    if (featureHeadingIndex >= 0) {
      for (var i = featureHeadingIndex + 1; i < nodes.length && candidates.length < 5; i += 1) {
        var node = nodes[i];
        // A following heading starts a different description section; headings
        // are labels, never product highlights themselves.
        if (/^h[2-6]$/i.test(node.tagName)) break;
        if (node.tagName === 'UL' || node.tagName === 'OL') {
          Array.from(node.querySelectorAll('li')).forEach(function (item) {
            if (candidates.length < 5) candidates.push(item.textContent.trim());
          });
        }
      }
    }
    Array.from(new Set(candidates.filter(Boolean))).slice(0, 5).forEach(function (text) {
      var item = list.ownerDocument.createElement('li');
      item.dataset.v2HighlightItem = '';
      item.textContent = text;
      list.appendChild(item);
    });
    list.hidden = list.children.length === 0;
  }

  function normalizeMediaId(value) {
    return String(value || '').split('/').pop();
  }

  function setupGallery(section) {
    var gallery = section.querySelector('[data-v2-gallery]');
    if (!gallery) return;
    var items = Array.from(gallery.querySelectorAll('[data-v2-media-item]'));
    var controls = Array.from(gallery.querySelectorAll('[data-v2-media-control]'));
    var previous = gallery.querySelector('[data-v2-gallery-prev]');
    var next = gallery.querySelector('[data-v2-gallery-next]');
    var index = 0;

    function pauseMedia(item) {
      item.querySelectorAll('video').forEach(function (video) {
        if (!item.classList.contains('is-active')) video.pause();
      });
    }

    function syncLocalizedImageAlt(item) {
      var image = item && item.querySelector('img');
      if (!image) return;
      var localizedAlt = image.getAttribute('data-localized-alt') || image.getAttribute('alt');
      if (localizedAlt) image.alt = localizedAlt;
    }

    function select(nextIndex) {
      if (!items.length) return;
      index = (Number(nextIndex) + items.length) % items.length;
      items.forEach(function (item, itemIndex) {
        var active = itemIndex === index;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        pauseMedia(item);
        if (active) syncLocalizedImageAlt(item);
      });
      controls.forEach(function (control) {
        var active = Number(control.dataset.mediaIndex) === index;
        control.classList.toggle('is-active', active);
        control.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (previous) previous.hidden = items.length < 2;
      if (next) next.hidden = items.length < 2;
    }

    controls.forEach(function (control) {
      control.addEventListener('click', function () { select(control.dataset.mediaIndex); });
    });
    if (previous) previous.addEventListener('click', function () { select(index - 1); });
    if (next) next.addEventListener('click', function () { select(index + 1); });
    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); select(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); select(index + 1); }
    });

    var touchStartX = 0;
    var touchStartY = 0;
    gallery.addEventListener('touchstart', function (event) {
      if (!event.touches.length) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });
    gallery.addEventListener('touchend', function (event) {
      if (!event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      var deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) select(index + (deltaX < 0 ? 1 : -1));
    }, { passive: true });

    section._v2SelectMedia = function (mediaId) {
      if (!mediaId) return;
      var target = normalizeMediaId(mediaId);
      var targetIndex = items.findIndex(function (item) { return normalizeMediaId(item.dataset.mediaId) === target; });
      if (targetIndex >= 0) select(targetIndex);
    };
    select(0);
  }

  function variantMediaId(variant) {
    return variant && (
      (variant.featured_media && variant.featured_media.id) ||
      (variant.featured_image && variant.featured_image.id) ||
      variant.featured_media_id ||
      variant.featured_image_id
    );
  }

  function setupQuantity(section) {
    var selectors = section.querySelectorAll('[data-v2-quantity]');
    if (!selectors.length) return;

    Array.prototype.forEach.call(selectors, function (quantity) {
      if (quantity.dataset.v2QuantityInitialized === 'true') return;

      var input = quantity.querySelector('input');
      var decrease = quantity.querySelector('[data-v2-quantity-decrease]');
      var increase = quantity.querySelector('[data-v2-quantity-increase]');
      if (!input || !decrease || !increase) return;

      quantity.dataset.v2QuantityInitialized = 'true';

      var minimumValue = Number(input.getAttribute('min') || input.dataset.min || 1);
      var minimum = Number.isFinite(minimumValue) ? Math.max(1, minimumValue) : 1;
      var maximumValue = Number(input.getAttribute('max') || input.dataset.max || 0);
      var maximum = Number.isFinite(maximumValue) && maximumValue > 0 ? maximumValue : null;
      var stepValue = Number(input.getAttribute('step') || input.dataset.step || 1);
      var step = Number.isFinite(stepValue) && stepValue > 0 ? stepValue : 1;

      function normalize(value) {
        var numeric = Number(value);
        if (!Number.isFinite(numeric)) numeric = minimum;
        numeric = Math.max(minimum, numeric);
        if (maximum !== null) numeric = Math.min(maximum, numeric);
        var steps = Math.round((numeric - minimum) / step);
        numeric = minimum + steps * step;
        if (maximum !== null) numeric = Math.min(maximum, numeric);
        return numeric;
      }

      function syncState() {
        var value = normalize(input.value);
        input.value = String(value);
        var atMinimum = value <= minimum;
        var atMaximum = maximum !== null && value >= maximum;
        decrease.disabled = atMinimum;
        increase.disabled = atMaximum;
        decrease.setAttribute('aria-disabled', String(atMinimum));
        increase.setAttribute('aria-disabled', String(atMaximum));
      }

      function setValue(value) {
        var previous = input.value;
        input.value = String(normalize(value));
        syncState();
        if (input.value !== previous) input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      decrease.addEventListener('click', function () {
        setValue(Number(input.value) - step);
      });
      increase.addEventListener('click', function () {
        setValue(Number(input.value) + step);
      });
      input.addEventListener('input', syncState);
      input.addEventListener('change', syncState);
      syncState();
    });
  }

  function setupVariants(section) {
    var variants = parseJsonAttribute(section, 'data-v2-variants', []);
    var idInput = section.querySelector('[data-v2-variant-id]');
    var form = section.querySelector('form');
    var selected = variants.find(function (variant) { return String(variant.id) === String(idInput && idInput.value); }) || variants[0];
    var price = section.querySelector('[data-v2-current-price]');
    var comparePrice = section.querySelector('[data-v2-compare-price]');
    var discount = section.querySelector('[data-v2-discount]');
    var availability = section.querySelector('[data-v2-availability]');
    var addButton = section.querySelector('[data-v2-main-submit]');
    var addLabel = section.querySelector('[data-v2-add-label]');
    var stickyButton = section.querySelector('[data-v2-sticky-submit]');
    var stickyPrice = section.querySelector('[data-v2-sticky-price]');
    var labels = {
      inStock: section.dataset.v2LabelInStock || 'In stock',
      soldOut: section.dataset.v2LabelSoldOut || 'Sold out',
      addToCart: section.dataset.v2LabelAddToCart || 'Add to cart'
    };
    if (!selected || !form || !idInput || !addButton) return;

    function optionsFromInputs() {
      var values = [];
      section.querySelectorAll('[data-v2-option-group]').forEach(function (group) {
        var checked = group.querySelector('[data-v2-option-input]:checked');
        values[Number(group.dataset.optionIndex)] = checked ? checked.dataset.optionValue : '';
      });
      return values;
    }

    function applyVariant(variant) {
      selected = variant;
      idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      var compareValue = Number(variant.compare_at_price || 0);
      var currentValue = Number(variant.price || 0);
      if (comparePrice && compareValue > currentValue) {
        comparePrice.textContent = formatMoney(compareValue);
        comparePrice.classList.remove('is-hidden');
        if (discount) {
          discount.textContent = 'Save ' + Math.round((1 - currentValue / compareValue) * 100) + '%';
          discount.classList.remove('is-hidden');
        }
      } else {
        if (comparePrice) {
          comparePrice.textContent = '';
          comparePrice.classList.add('is-hidden');
        }
        if (discount) {
          discount.textContent = '';
          discount.classList.add('is-hidden');
        }
      }
      var available = Boolean(variant.available);
      if (availability) availability.textContent = available ? labels.inStock : labels.soldOut;
      addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? labels.addToCart : labels.soldOut;
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = available ? labels.addToCart : labels.soldOut;
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var selectedValues = optionsFromInputs();
      section.querySelectorAll('[data-v2-option-input]').forEach(function (input) {
        var optionIndex = Number(input.dataset.optionIndex);
        var combinationExists = variants.some(function (candidateVariant) {
          return candidateVariant.options[optionIndex] === input.dataset.optionValue && candidateVariant.options.every(function (value, index) {
            return !selectedValues[index] || value === selectedValues[index] || index === optionIndex;
          });
        });
        input.disabled = !combinationExists;
        var label = input.closest('[data-v2-option-label]');
        if (label) {
          label.classList.toggle('is-unavailable', !combinationExists);
          label.classList.toggle('is-selected', input.checked);
          label.setAttribute('aria-disabled', String(!combinationExists));
        }
      });
      if (section._v2SelectMedia) section._v2SelectMedia(variantMediaId(variant));
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    section.querySelectorAll('[data-v2-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var values = optionsFromInputs();
        var variant = variants.find(function (candidate) {
          return candidate.options.every(function (value, index) { return value === values[index]; });
        });
        if (variant) applyVariant(variant);
      });
    });
    section.querySelectorAll('[data-v2-option-label]').forEach(function (label) {
      label.addEventListener('click', function (event) {
        var input = document.getElementById(label.getAttribute('for'));
        if (!input || input.disabled) return;
        event.preventDefault();
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    form.addEventListener('submit', function () {
      addButton.setAttribute('aria-busy', 'true');
      var label = addButton.querySelector('[data-v2-add-label]');
      var loading = addButton.querySelector('[data-v2-add-loading]');
      if (label) label.hidden = true;
      if (loading) loading.hidden = false;
      window.setTimeout(function () {
        addButton.removeAttribute('aria-busy');
        if (label) label.hidden = false;
        if (loading) loading.hidden = true;
      }, 2500);
    });
    if (stickyButton) stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled) return;
      if (form.requestSubmit) form.requestSubmit(addButton);
      else addButton.click();
    });
    applyVariant(selected);
  }

  function setupMobileSticky(section) {
    var sticky = section.querySelector('[data-v2-mobile-sticky]');
    var mainButton = section.querySelector('[data-v2-main-submit]');
    if (!sticky || !mainButton || !('IntersectionObserver' in window)) return;
    var mobileQuery = window.matchMedia('(max-width: 989px)');

    function updateStickyVisibility() {
      var mainButtonRect = mainButton.getBoundingClientRect();
      // An offscreen CTA below the fold is not "passed". Reveal the fixed CTA
      // only after the primary button has fully crossed above the viewport.
      sticky.hidden = !mobileQuery.matches || mainButtonRect.bottom > 0;
    }

    var observer = new IntersectionObserver(updateStickyVisibility, { threshold: [0, 0.15, 1] });
    observer.observe(mainButton);
    window.addEventListener('resize', updateStickyVisibility, { passive: true });
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', updateStickyVisibility);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(updateStickyVisibility);
    }

    function cleanup() {
      observer.disconnect();
      window.removeEventListener('resize', updateStickyVisibility);
      if (mobileQuery.removeEventListener) {
        mobileQuery.removeEventListener('change', updateStickyVisibility);
      } else if (mobileQuery.removeListener) {
        mobileQuery.removeListener(updateStickyVisibility);
      }
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
    }

    function handleSectionUnload(event) {
      if (event.detail && event.detail.sectionId === section.dataset.sectionId) cleanup();
    }

    document.addEventListener('shopify:section:unload', handleSectionUnload);
    sticky.hidden = true;
    updateStickyVisibility();
  }

  function init(section) {
    parseDescription(section);
    deriveHighlights(section);
    hideEmptyPanels(section);
    setupDetails(section);
    setupGallery(section);
    setupQuantity(section);
    setupVariants(section);
    setupMobileSticky(section);
    fitTitle(section.querySelector('[data-v2-fit-title]'));
    section.querySelectorAll('[data-v2-fit-one-line]').forEach(fitSingleLine);
    window.addEventListener('resize', function () {
      fitTitle(section.querySelector('[data-v2-fit-title]'));
      section.querySelectorAll('[data-v2-fit-one-line]').forEach(fitSingleLine);
      activateTab(section, section.querySelector('[data-v2-tab][aria-selected="true"]')?.dataset.v2Tab || 'overview');
    }, { passive: true });
  }

  document.querySelectorAll('[data-v2-section]').forEach(init);
})();


